import { PropsWithChildren } from 'react';
import { Typography, TypographyProps } from '@mui/material';

export default function StrippedTypo({
    children,
    ...props
}: PropsWithChildren<TypographyProps>) {
    const tagEle = document.createElement('div');
    if (typeof children === 'string') {
        tagEle.innerHTML = children;
    } else {
        console.warn(
            'Component "StrippedTypo" accepts only string as children!',
        );
    }

    return <Typography {...props}>{tagEle.innerText}</Typography>;
}
